import React, { useMemo } from 'react'
import { bool, func, number, oneOf, string } from 'prop-types'

import { FILE_ACCEPT_TYPES } from '../../constants/file.js'
import { getDefaultDragValidations, getDefaultFileSelectValidations, getFileItemsErrors } from '../../util/file'
import { FileDndContextProvider } from './file-dnd-context-provider'
import { FileDndDropzone } from './file-dnd-dropzone'

const propTypes = {
    accept: string,
    acceptType: oneOf(Object.values(FILE_ACCEPT_TYPES)),
    dropLayerText: string,
    multiple: bool,
    onChange: func.isRequired,
    onInvalidFile: func,
    maxSize: number
}

const defaultProps = {
    acceptType: FILE_ACCEPT_TYPES.MIME_TYPES,
    dndLayer: null,
    dropLayerText: '',
    multiple: false,
    onInvalidFile: Function.prototype
}

export const DragAndDropArea = function (props) {
    const { accept, acceptType, children, className, dropLayerText, maxSize, multiple } = props
    const dropValidations = useMemo(
        () => getDefaultFileSelectValidations(multiple, maxSize, accept),
        [multiple, accept, maxSize]
    )
    const dragValidations = useMemo(
        () => getDefaultDragValidations(multiple, accept, acceptType),
        [multiple, accept, acceptType]
    )

    function onFileDrop(event) {
        const { multiple, onChange, onInvalidFile } = props
        const fileList = event.dataTransfer.files
        const errors = getFileItemsErrors(fileList, dropValidations)

        if (errors.length === 0) {
            onChange(multiple ? fileList : fileList[0])
        } else {
            onInvalidFile(errors)
        }
    }

    return (
        <FileDndContextProvider validateFileItems={items => getFileItemsErrors(items, dragValidations).length === 0}>
            <FileDndDropzone {...{ children, className, dropLayerText, onFileDrop }} />
        </FileDndContextProvider>
    )
}

DragAndDropArea.propTypes = propTypes
DragAndDropArea.defaultProps = defaultProps
